module.exports = "/dist/assets/images/arrow-right-double.svg";